var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRightChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 13,
  fill: "none",
  viewBox: "0 0 8 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#267AC0",
  d: "m0 1.522 4.945 4.956L0 11.433l1.522 1.522L8 6.478 1.522 0 0 1.522Z"
})));
export { SvgRightChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDEuNTIyMjVMNC45NDQ2NyA2LjQ3NzcxTDAgMTEuNDMzMkwxLjUyMjI3IDEyLjk1NTRMOCA2LjQ3NzcxTDEuNTIyMjcgLTIuMTQ1NzdlLTA1TDAgMS41MjIyNVoiIGZpbGw9IiMyNjdBQzAiLz4KPC9zdmc+Cg==";